import React from 'react';
import PropTypes from 'prop-types';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';

const DegreePlus = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes, existSt } = generateGridStyles(gridStyles, name);
    const isValueNegative = val.startsWith('-');
    const plus = {
        background: 'var(--greenSuperExtraTransparentColor)',
        color: 'var(--greenColor)',
        padding: '4px 6px',
        borderRadius: '4px'
    };
    const degree = {
        background: 'var(--redDarkExtraTransparent)',
        color: 'var(--redDarkColor)',
        padding: '4px 6px',
        'border-radius': '4px'
    };
    return (
        <div {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper} key={generateUniqueId()}>
            <p className={classes.p} style={existSt('p') || { color: 'var(--darkColor)' }}>
                <p style={isValueNegative ? degree : plus}> {isValueNegative || val === '0' ? val : `+${val}`} </p>
            </p>
        </div>
    );
};
DegreePlus.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default DegreePlus;
